import {Box, FormControl, InputLabel, MenuItem, Typography} from "@mui/material";
import Select, {SelectChangeEvent} from '@mui/material/Select';
import React, {useState} from "react";
import View from "../../components/View";
import Page from "../../components/Page";
import formulas from "../../services/formulas";

const EAD = () => {

    const {calcMod} = formulas();
    const [ppO2, setPpO2] = useState(1.4);
    const [mix, setMix] = useState(32);
    const [mod, setMod] = useState(33);

    const changePPO2 = (event: SelectChangeEvent) => {
        const value = parseFloat(event.target.value);
        setPpO2(value)
        setMod(calcMod(mix, value))
    }

    const changeMix = (event: SelectChangeEvent) => {
        const value = parseInt(event.target.value);
        setMix(value)
        setMod(calcMod(value, ppO2));
    }

    // @ts-ignore
    return (
        <Page>
            <View>
                <Typography variant="h6" sx={{mt: 1, mb: 1}}>Maximum Operating Depth</Typography>
                <Typography variant="h6"><Box component="span" sx={{border: '1px solid grey', p: 1}}>{mod.toFixed(0)}</Box> Meters</Typography>
                <FormControl variant="standard" sx={{m: 2, minWidth: 90}}>
                    <InputLabel id="ppO2">ppO2</InputLabel>
                    <Select
                        labelId="ppO2"
                        id="ppO2"
                        value={ppO2.toString()}
                        label="ppO2"
                        onChange={changePPO2}
                    >
                        <MenuItem key={1.2} value={1.2}>{1.2}</MenuItem>
                        <MenuItem key={1.3} value={1.3}>{1.3}</MenuItem>
                        <MenuItem key={1.4} value={1.4}>{1.4}</MenuItem>
                        <MenuItem key={1.5} value={1.5}>{1.5}</MenuItem>
                        <MenuItem key={1.6} value={1.6}>{1.6}</MenuItem>
                    </Select>
                </FormControl>
                <FormControl variant="standard" sx={{m: 2, minWidth: 90}}>
                    <InputLabel id="mix">Mix</InputLabel>
                    <Select
                        labelId="mix"
                        id="mix"
                        value={mix.toString()}
                        label="Mix"
                        onChange={changeMix}
                    >
                        {[...Array(100)].map((x, i: number) => (
                            <MenuItem key={x} value={1 + i}>{1 + i}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </View>
            <View>
                <Typography style={{fontWeight: 'bold'}}>Maximum Operating Depth (MOD)</Typography>
                <Typography style={{marginTop: 10}}>
                    Is the maximum safe depth at which a given Nitrox mixture
                    can be used. MOD depends on the allowed partial pressure of oxygen, which is related to
                    exposure time and the acceptable risk assumed for central nervous system oxygen toxicity.
                    Acceptable maximum ppO2 varies depending on the application.
                </Typography>
            </View>
        </Page>
    );
}

export default EAD;